import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import BasicInfo from './BasicInfo'
import { FormattedMessage } from 'react-intl'
import { SearchLoader } from '../Loader/SearchLoader'
import Alert from '@material-ui/lab/Alert'
import { AuthenticatedUserConsumer } from '../../AuthenticatedUserContext'
import { LanguageConsumer } from '../../LanguageContext'
import PageTitle from '../Dashboard/PageTitle/PageTitle'

const EditProfileContent = ({ getCountries }) => {
  const classes = useStyles()
  React.useEffect(() => {
      getCountries()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <>
      <PageTitle title={<FormattedMessage id='EditProfileContent.title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <div className={classes.EditProfileContent}>
            <AuthenticatedUserConsumer>
              {({ userDataLoading, userDataFailure, userData }) => (
                <>
                  {!!userDataLoading && <SearchLoader loading={true}/>}
                  {!!userDataFailure &&
                  <Alert severity="error"><FormattedMessage id='BasicInfo.FormErrorAlert'/></Alert>
                  }
                  {!!userData && !!Object.keys(userData).length &&
                  <>
                    <LanguageConsumer>
                      {({ locale }) => (
                        <BasicInfo userData={userData} locale={locale}/>
                      )}
                    </LanguageConsumer>
                  </>
                  }
                </>
              )}
            </AuthenticatedUserConsumer>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default EditProfileContent
